<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Date</div>
      <div class="modal-body" *ngIf="formGroup">
        <frg-form-input
          id="date"
          type="date"
          label="Date de la consultation"
          [formGroup]="formGroup"
          [control]="formGroup.get('date')"
        ></frg-form-input>
      </div>
      <div class="button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button (activated)="validDate()">Valider</frg-button>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>